import React from 'react';
import {
  datetime,
  type DatetimeType,
  type Moment,
} from '@common/services/datetime';

// NOTE: Moment stays in the union because antd v4 picker and GraphQL call sites
// hold one; createDatetime takes it at runtime, datetime()'s signature does not.
type DateProp = string | DatetimeType | Moment | Date;

const toDatetime = (date: DateProp): DatetimeType =>
  datetime(date as Exclude<DateProp, Moment>);

export const LocalDate = ({ date }: { date: DateProp }) => {
  const formattedDate = toDatetime(date).format('MM/DD/YYYY');

  return <> {formattedDate} </>;
};
